import { useMemo } from "react"
import { get } from "lodash"
import clsx from "clsx"

import { useVenueController } from "hooks/venue"
import { useVenue } from "providers/venue"
import {
  CarouselNavigation,
  ICarouselNavigationProps,
} from "components/CarouselNavigation"

// Make sure the useVenueController will get current active venue id when using in AppNavigation
export const MainCarouselNavigation: React.FC<ICarouselNavigationProps> = (
  props
) => {
  const { viewingVenue } = useVenueController()
  const { venues } = useVenue()

  const currentVenue = useMemo(() => {
    const venue = venues.find((venue) => venue?.id === viewingVenue) || {}
    return get(venue, "properties.reference", "all")
  }, [venues, viewingVenue])

  return (
    <CarouselNavigation
      className={clsx("MainCarouselNavigation-root", currentVenue)}
      {...props}
    />
  )
}
